'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

/**
 * 水平滑块
 */
var HSlider = React.createClass({
  render: function () {
    var trackStyle;
    var sliderStyle;
    var progress = styleHelper.getInt(this.props, propConst.PROGRESS);
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var state = styleHelper.getPropertyValue(this.props,propConst.STATUS);
    if(!state){
      state = this.props[propConst.STATE];
    }
    var bg = state === appTypes.ComStatus2.DISABLE ? appTypes.Color.MODEL_DISABLE : '#000';

    trackStyle = {
      top: (h - 2) / 2,
      backgroundColor: bg
    };
    sliderStyle = {
      left: (progress / 100) * w
    };

    return (<div>
      <div style={trackStyle} className="track"></div>
      <div style={sliderStyle} className="slide">
        <div className="slide-shape" style={{borderBottomColor:bg}}></div>
      </div>
    </div>)
  }
});

module.exports = HSlider;



/** WEBPACK FOOTER **
 ** ./src/views/Components/HSlider.jsx
 **/